"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_hooks_1 = require("@l2p/common-hooks");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Timer = function (_a) {
    var endDate = _a.endDate;
    var time = (0, common_hooks_1.useTimer)({
        endDate: endDate,
    }).time;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.timer },
        time.days ? "".concat(time.days, ":") : '',
        time.hours,
        ":",
        time.minutes,
        ":",
        time.seconds));
};
exports.default = Timer;
